/**
 * @generated SignedSource<<c04fe66b7b42ecbe025ab1dc6f79a664>>
 * @relayHash 75d5038cebaa755baa14667ba330cb3a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf31ede343abcf39655f3d91d05e6dbdd307e2d1833acc93d68031c3df52868b

import type { ConcreteRequest } from 'relay-runtime';
export type AssetsVerticalPermissionCheckInput = {
  dontRequirePrincipalInSite?: boolean | null;
  permissionId: string;
  resourceId: string;
};
export type fetchItamHamWorkspacePermissionsQuery$variables = {
  checks: ReadonlyArray<AssetsVerticalPermissionCheckInput>;
  cloudId: string;
};
export type fetchItamHamWorkspacePermissionsQuery$data = {
  readonly assetsVertical_checkPermissions: {
    readonly __typename: "AssetsVerticalCheckPermissionsSuccess";
    readonly results: ReadonlyArray<{
      readonly permissionId: string;
      readonly permitted: boolean;
      readonly resourceId: string;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type fetchItamHamWorkspacePermissionsQuery = {
  response: fetchItamHamWorkspacePermissionsQuery$data;
  variables: fetchItamHamWorkspacePermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checks"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "checks",
        "variableName": "checks"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "LinkedField",
    "name": "assetsVertical_checkPermissions",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "concreteType": "AssetsVerticalPermissionCheckResult",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "resourceId"
              },
              {
                "kind": "ScalarField",
                "name": "permissionId"
              },
              {
                "kind": "ScalarField",
                "name": "permitted"
              }
            ]
          }
        ],
        "type": "AssetsVerticalCheckPermissionsSuccess"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "fetchItamHamWorkspacePermissionsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchItamHamWorkspacePermissionsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "bf31ede343abcf39655f3d91d05e6dbdd307e2d1833acc93d68031c3df52868b",
    "metadata": {},
    "name": "fetchItamHamWorkspacePermissionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da7c453fc0f6e43da430f072b03fa7f7";

export default node;
